import { axiosIns } from './index';
import { ApiResponse } from '../typings/ApiResponse';
import { ProfileData, PartnerCarehomeData } from '../typings/ProfileTypes';

const getProfileDetails = async (): Promise<ApiResponse<ProfileData>> => {
  const response = await axiosIns.get('/carehome/member/profile');
  return response.data;
};

const editProfile = async (id: any, avatar: any) => {
  const response = await axiosIns.put('/carehome/member/profile', {
    avatar,
  });
  return response.data;
};

const getCarehomePartners = async (): Promise<
  ApiResponse<PartnerCarehomeData[]>
> => {
  const response = await axiosIns.get(`/carehome/member/partners`);
  return response.data;
};

const addCarehomeInfo = async (id: string, address: any) => {
  const { addressLine1, addressLine2, city, county, postCode } = address;
  const response = await axiosIns.post('/carehome/teams/info', {
    carehome_partner_id: id,
    address_line1: addressLine1,
    address_line2: addressLine2,
    city,
    county,
    post_code: postCode,
  });
  return response.data;
};

export { getProfileDetails, editProfile, getCarehomePartners, addCarehomeInfo };
